"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_sms__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "c2ff0017-a0b2-411c-8c4b-0e8255946299",
    "data-name": "SMS_ic_hi",
    viewBox: "0 0 191.5 191.5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.06,93.18",
    fill: "none",
    stroke: "#fecb00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,104.46,36,128V104.29H29a13,13,0,0,1-13-13V37A13,13,0,0,1,29,24h78a13,13,0,0,1,13,13V91.49a13,13,0,0,1-13,13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,104.46,36,128V104.29H29a13,13,0,0,1-13-13V37A13,13,0,0,1,29,24h78a13,13,0,0,1,13,13V91.49a13,13,0,0,1-13,13Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107,102.47a13,13,0,0,0,13-13v2a13,13,0,0,1-13,13H60L36,128v-2l24-23.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,102.29h7v2H29a13,13,0,0,1-13-13v-2A13,13,0,0,0,29,102.29Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.53,144,156,168V144h7a12.78,12.78,0,0,0,13-12.74V77a13,13,0,0,0-13-13H85A13,13,0,0,0,72,77v54a13,13,0,0,0,13,13Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85,142a13,13,0,0,1-13-13v2a13,13,0,0,0,13,13h47.56L156,168v-2l-23.47-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,142h-7v2h7a12.78,12.78,0,0,0,13-12.74v-2A12.78,12.78,0,0,1,163,142Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 92.22,
    y: 100.01,
    width: 63.83,
    height: 3.99,
    rx: 1.99,
    ry: 1.99,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.01,
    y: 82,
    width: 64.05,
    height: 3.99,
    rx: 1.99,
    ry: 1.99,
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.22,
    y: 118.01,
    width: 63.83,
    height: 3.99,
    rx: 1.99,
    ry: 1.99,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "cc4d434d-8643-4a12-b9d7-dfa5f5e09567",
    "data-name": "Bounding Box",
    points: "0 191.5 0 0 191.5 0 191.5 191.5 0 191.5",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "sms-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "6c3beff2-7a83-4375-b5df-80cf5aa6e8f9",
    "data-name": "sms_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "450bc014-5421-4de4-ab68-8153680c8424",
    "data-name": "SMS_ic_hi",
    width: 191.5,
    height: 191.5,
    transform: "translate(0.25 0.25)",
    xlinkHref: "#c2ff0017-a0b2-411c-8c4b-0e8255946299"
  })));
}

var _default = ic_sms__dark;
exports.default = _default;